import React, {FC, useEffect, useState} from 'react';
import './service-link-img.scss';
import ArrowIcon from './arrow.svg';
import {getImgUrl} from "/react4xp/parts/service-link-img/actions";

const ServiceLinkImg: FC = (props: any) => {
    const [st, setSt] = useState({});

    useEffect(() => {
        if (props.imgSrc) {
            setSt({
                background: `url(${props.imgSrc}) 100% 100% / cover no-repeat`,
            });
            return;
        }

        if (!props.img) {
            setSt({});
            return;
        }

        let isMounted = true;

        if (props.img) {
            getImgUrl(props.img, props.context).then(
                value => {
                    if (isMounted && value.data) {
                        setSt({
                            background: `url(${value.data}) 100% 100% / cover no-repeat`,
                        });
                    }
                }
            );
        }

        return () => {
            isMounted = false;
        };
    }, [props.img, props.imgSrc, props.context]);

    const getUrl = () => {
        if (props.isRedirect) {
            return props.redirectUrl;
        }

        return props.url;
    };

    return (
        <a
            className={`service-link-img ${props.className || ''}`}
            style={st}
            href={getUrl()}
            target={props.isBlank ? '_blank' : undefined}
            rel={props.isBlank ? 'noopener noreferrer' : undefined}
        >
            <span
                style={{
                    maxWidth: +props.maxWidth,
                }}
            >
                {props.name}
            </span>
            <ArrowIcon />
        </a>
    );
};

export default ServiceLinkImg;
